import { csrfFetch } from 'javascripts/csrf_token';
import React from 'react';
import UserSelector from '../UserSelector/UserSelector';
import { type UserSelectorProps } from '../UserSelector/UserSelector';

type AttendeesProps = Omit<UserSelectorProps, 'onSelect' | 'onClear'> & {
  toggleUrl?: string;
  clearUrl?: string;
};

const Attendees: React.FC<AttendeesProps> = ({
  toggleUrl,
  clearUrl,
  ...props
}) => {
  const selectCallback = (user_id: string, selected: boolean) => {
    return csrfFetch(toggleUrl, {
      method: 'PUT',
      body: JSON.stringify({
        toggle: selected ? '1' : '0',
        meeting_attendee: {
          user_id,
        },
      }),
    });
  };

  const clearCallback = () => {
    return csrfFetch(clearUrl, {
      method: 'DELETE',
    });
  };

  return (
    <UserSelector
      {...props}
      onSelect={selectCallback}
      onClear={clearCallback}
    />
  );
};

export default Attendees;
